@if (context$ | async; as context) {
  <!-- Image Mobile-->
  <ng-container *ifScreenSize="screenSize.Mobile">
    <div class="loyalty-details-image card border-0 overflow-hidden p-0 fgbcl-rewards-image">
      <img
        class="card-img"
        src="{{ context.item.ImageName | contentImage: '7' : 'lotto' }}"
        [alt]="context.item.Title"
        draggable="false"
      />
      <fgbcl-social-share-modal
        shareType="rewards"
        [itemId]="lottoId"
        urlPage="rewards/raffles/details"
        [loyaltyCategoryType]="loyaltyCategoryType"
      ></fgbcl-social-share-modal>
      @if (context.item.NumberOfTicketsPurchasedByAccount) {
        <div class="corner-number-entries lotto-mobile" aria-live="polite">
          <span class="number-entries">
            {{ ('lotto.my.entries' | translate) + context.item.NumberOfTicketsPurchasedByAccount }}
          </span>
        </div>
      }
    </div>
  </ng-container>
  <div class="container">
    @if (context.item) {
      <div class="d-block d-lg-flex">
        <!-- Image -->
        <ng-container *ifScreenSize="screenSize.Desktop">
          <div class="loyalty-details-image card border-0 p-0" data-version="2">
            <img
              class="card-img"
              src="{{ context.item.ImageName | contentImage: '7' : 'lotto' }}"
              [alt]="context.item.Title"
              draggable="false"
            />
            <fgbcl-social-share-modal
              shareType="rewards"
              [itemId]="lottoId"
              urlPage="rewards/raffles/details"
              [loyaltyCategoryType]="loyaltyCategoryType"
            ></fgbcl-social-share-modal>
            @if (context.item.NumberOfTicketsPurchasedByAccount) {
              <div class="corner-number-entries" aria-live="polite">
                <span class="number-entries">
                  {{ ('lotto.my.entries' | translate) + context.item.NumberOfTicketsPurchasedByAccount }}
                </span>
              </div>
            }
          </div>
        </ng-container>
        <!-- Details -->
        <div class="loyalty-details">
          <!--Sponsor-->
          @if (context.item?.Sponsor?.SponsorImage) {
            <div class="rewards-details-sponsor">
              <span class="rewards-details-sponsor-text"> {{ context.item?.Sponsor?.SponsorText }} </span>
              <a
                target="_blank"
                href="{{ context.item?.Sponsor?.SponsorLink }}"
                [attr.aria-label]="'Sponsor: ' + context.item?.Sponsor?.SponsorName"
                rel="noopener noreferrer"
              >
                <img
                  src="{{ context.item?.Sponsor?.SponsorImage | contentImage: '7' : 'lotto' }}"
                  [alt]="context.item?.Sponsor?.SponsorName"
                />
              </a>
            </div>
          }
          <h2 class="rewards-item-name">{{ context.item.Title }}</h2>
          <!-- Card Body -->
          <div class="d-flex flex-column justify-content-between">
            <!-- Enabled Item Display -->
            @if (!lottoStatus()?.disabled) {
              <!-- Item Details -->
              <!-- End Time -->
              <fgbcl-countdown-v2
                class="font-size-14 countdown-color rewards-item-end-date"
                [startDateTime]="context.item.RequestTime"
                [endDateTime]="context.item.EndDate"
                (complete)="lottoEnd()"
              ></fgbcl-countdown-v2>
              <!-- Points -->
              @if (context.item.PurchasePrice > 0) {
                <!--  || context.item?.ItemState !== 0
                   -->
                <span class="rewards-item-details" [attr.aria-label]="(context.item.PurchasePrice | number) + ' points'">
                  {{ context.item.PurchasePrice | number }} {{ 'fgbcl.currency.pts' | translate }}</span
                >
              } @else {
                <span class="rewards-item-details" aria-label="Free entry"> {{ 'fgbcl.lottos.item.free' | translate }}</span>
              }

              @if (lottoDetailsForm) {
                <div
                  class="marketplace-detail-form"
                  [formGroup]="lottoDetailsForm"
                  [class.form-invalid]="lottoDetailsForm?.get('quantity')?.disabled"
                >
                  <!-- Custom Fields -->
                  @if (context.item.CustomFields?.length > 0) {
                    <div class="custom-fields" formArrayName="customFields">
                      @for (field of context.item.CustomFields; track field.CustomFieldId; let i = $index) {
                        <div [formGroup]="lottoDetailsForm.get('customFields')?.controls[i]">
                          <fgbcl-custom-field [field]="field" formControlName="customFieldValue" />
                        </div>
                      }
                    </div>
                  }

                  <!--Terms and Condtions Checkbox-->
                  @if (context.item.ShowTermsAndConditions) {
                    <div
                      class="form-check rewards-accept-terms-checkbox"
                      data-version="2"
                      [ngClass]="lottoDetailsForm.get('acceptTerms')?.value ? 'rewards-terms-checked' : 'rewards-terms-unchecked'"
                    >
                      <input
                        formControlName="acceptTerms"
                        class="form-check-input"
                        id="accept-terms"
                        type="checkbox"
                        (change)="onAcceptTermsChange(lottoDetailsForm.get('acceptTerms')?.value)"
                        aria-required="true"
                      />
                      <label
                        [ngClass]="
                          lottoDetailsForm.get('acceptTerms')?.value ? 'rewards-terms-checked' : 'rewards-terms-unchecked'
                        "
                        class="rewards-terms-label ms-1"
                        for="accept-terms"
                      >
                        {{ 'lotto.terms.accept' | translate }}
                      </label>
                    </div>
                  }
                  <!-- Bottom Buttons -->
                  <div>
                    <!-- [ngClass]="{ 'd-none': statusDisableManualEntry() }" -->
                    <div class="rewards-button-background">
                      <div class="rewards-button-container">
                        <div class="rewards-quantity-field-container justify-content-center align-items-center">
                          <fgbcl-quantity-field [minValue]="minQuantity" [maxValue]="maxQuantity" formControlName="quantity" />
                        </div>

                        <button
                          class="btn fw-bold btn-rewards-redeem"
                          type="button"
                          (click)="openConfirmation(context.item)"
                          [disabled]="isEnterDisabled"
                          [attr.aria-disabled]="isEnterDisabled"
                          [attr.aria-label]="'Enter ' + context.item.Title"
                        >
                          {{ 'lottos.enter.now' | translate }}
                        </button>
                      </div>
                    </div>
                    <!-- Server Side Errors -->
                    <fgbcl-errors />
                    <!-- Form Errors -->
                    @if (lottoDetailsForm?.errors?.limitExceeded) {
                      <div class="error-message alert-danger" role="alert">
                        {{ 'lotto.error.item.limit.reached' | translate }}
                      </div>
                    }
                    @if (lottoDetailsForm?.errors?.maxQuantityExceeded) {
                      <div class="error-message alert-danger" role="alert">
                        {{ 'lotto.error.item.not.enough.points' | translate }}
                      </div>
                    }
                    @if (lottoDetailsForm?.get('quantity').hasError('min') && lottoDetailsForm?.get('quantity').touched) {
                      <div class="error-message alert-danger" role="alert">
                        {{ 'lotto.error.quantity.min' | translate: { min: minQuantity } }}
                      </div>
                    }
                    @if (lottoDetailsForm?.errors?.productLimitExceeded) {
                      <div class="error-message alert-danger" role="alert">
                        @if (lottoDetailsForm?.errors?.productLimitExceeded?.type === 1) {
                          {{
                            'lotto.error.product.limit.member.exceeded'
                              | translate: { max: lottoDetailsForm?.errors?.productLimitExceeded?.limit }
                          }}
                        } @else if (lottoDetailsForm?.errors?.productLimitExceeded?.type === 2) {
                          {{
                            'lotto.error.product.limit.account.exceeded'
                              | translate: { max: lottoDetailsForm?.errors?.productLimitExceeded?.limit }
                          }}
                        }
                      </div>
                    }
                  </div>
                </div>
              }
            } @else {
              <!-- Disabled Item Display  -->
              @if (
                lottoStatus()?.statusText !== LOTTO_STATE.COMING_SOON &&
                lottoStatus()?.statusText !== LOTTO_STATE.SOLD_OUT &&
                lottoStatus()?.statusText !== LOTTO_STATE.LOCKED
              ) {
                <!-- End Time -->

                <fgbcl-countdown-v2
                  class="rewards-item-end-date font-size-14 countdown-color"
                  [startDateTime]="context.item.RequestTime"
                  [endDateTime]="context.item.EndDate"
                  (complete)="lottoEnd()"
                >
                </fgbcl-countdown-v2>
              }
              <!-- Points -->
              @if (context.item.PurchasePrice > 0) {
                <!--  || context.item?.ItemState !== 0 -->
                <span class="rewards-item-details" [attr.aria-label]="(context.item.PurchasePrice | number) + ' points'">
                  {{ context.item.PurchasePrice | number }} {{ 'fgbcl.currency.pts' | translate }}</span
                >
              } @else {
                <span class="rewards-item-details" aria-label="Free entry"> {{ 'fgbcl.lottos.item.free' | translate }}</span>
              }
              @if (lottoStatus()?.statusText !== LOTTO_STATE.VIEW) {
                <!-- Disabled Status -->
                <div class="status-container" role="status" aria-live="polite">
                  <div class="reward-disabled-status">
                    <div class="bg-{{ lottoStatus()?.theme }} reward-status" data-version="2">
                      @if (lottoStatus()?.statusText == LOTTO_STATE.LOCKED) {
                        <span class="icon material-icons" aria-hidden="true">lock</span>
                      }
                      <label>
                        {{ lottoStatus()?.statusText | translate }}
                      </label>
                      @if (lottoStatus()?.statusText == LOTTO_STATE.COMING_SOON) {
                        <fgbcl-countdown-v2
                          [startDateTime]="context.item.RequestTime"
                          [endDateTime]="context.item.StartDate"
                          (complete)="refresh()"
                        >
                        </fgbcl-countdown-v2>
                      }
                    </div>
                  </div>
                </div>
              }
            }
            <!-- Description & Terms  -->
            <div class="rewards-details-desc-terms accordion accordion-flush" id="marketplaceDescTerms">
              <div class="accordion-item rewards-accordion-item">
                <div id="marketplace-description">
                  <button
                    class="accordion-button rewards-accordion-item rewards-item-description-title"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#marketplaceDesc"
                    aria-expanded="true"
                    aria-controls="marketplaceDesc"
                  >
                    {{ 'lotto.item.description' | translate }}
                  </button>
                </div>
                <div
                  id="marketplaceDesc"
                  class="accordion-collapse collapse show"
                  data-bs-parent="#marketplaceDescTerms"
                  role="region"
                  aria-labelledby="marketplace-description"
                >
                  <div class="rewards-item-description" [innerHtml]="context.item.Description | safeHtml"></div>
                </div>
              </div>
              @if (context.item.ShowTermsAndConditions) {
                <div class="accordion-item rewards-accordion-item">
                  <div class="accordion-header" id="marketplace-terms">
                    <button
                      class="accordion-button collapsed rewards-item-terms"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#marketplaceTerms"
                      aria-expanded="false"
                      aria-controls="marketplaceTerms"
                    >
                      {{ 'lotto.item.tcs' | translate }}
                    </button>
                  </div>
                  <div
                    id="marketplaceTerms"
                    class="accordion-collapse collapse"
                    data-bs-parent="#marketplaceDescTerms"
                    role="region"
                    aria-labelledby="marketplace-terms"
                  >
                    <!--Text T&Cs-->
                    @if (context.item.TermsAndConditionsType === TermsAndCondtionsType.Text) {
                      <div class="rewards-item-terms-text" [innerHtml]="context.item.TermsAndConditions | safeHtml"></div>
                    }
                    <!--URL T&Cs-->
                    @if (context.item.TermsAndConditionsType === TermsAndCondtionsType.URL) {
                      <a
                        [href]="context.item.TermsAndConditions"
                        target="_blank"
                        class="rewards-item-terms-url"
                        rel="noopener noreferrer"
                        aria-label="View terms and conditions (opens in new tab)"
                        >{{ context.item.TermsAndConditions }}</a
                      >
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}
